// CallSignalRListener.tsx
import { useEffect } from "react";
import * as signalR from "@microsoft/signalr"; // FIXED: use * as signalR
import { useNotifications } from "./NotificationProvider";
import { useAuth } from "../firebase/AuthProvider";
import { Link, useNavigate } from "react-router-dom";
import { CallActionRequest, LobbyState } from "../interfaces/videocallDtos/videoCall";
import { NofifyForRingingOffDto, ReceiveGroupCallInviteResponse } from "../interfaces/videoHubResponse/videoHubResponse";
import { RejectVideoCallAsync } from "../services/videoService/VideoService";
import EventNotification from "../interfaces/eventNotification/EventNotification";
import React from "react";

const CallSignalRListener = () => {
    const { notify, notifyForCall, hideCallBanner } = useNotifications();
    const { currentUser } = useAuth(); // assuming this provides auth info
    const navigate = useNavigate();


    useEffect(() => {
        if (!currentUser) return; // Wait for user to be available

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_API_BASE_URL}/videoHub`, {
                accessTokenFactory: async () => {
                    // Get the token from Firebase Auth or wherever you store it
                    const token = await currentUser.getIdToken(true); // Firebase example
                    return token;
                },
            })
            .withAutomaticReconnect()
            .build();

        // for calling notification
        connection.on(
            "ReceiveGroupCallInvite",
            (hubResponse: ReceiveGroupCallInviteResponse) => { // conversation id may be calendereventId, conversationId
                console.log("Hub Data : ", hubResponse);
                
                const states: LobbyState = {
                    calenderEventId: hubResponse.calenderEventId,
                    targetUserId: null,
                    relatedChatConversationId: hubResponse.conversationId?.toString(),
                    isPublisher: false,
                    isOneToOneCall: false
                }

                notifyForCall(hubResponse, () => {
                    console.log("Call accepted");
                    navigate(`/lobby/${hubResponse.roomId}`, { state: states });
                }, () => {
                    connection.invoke("RejectCall", hubResponse.roomId, hubResponse.callerId, currentUser.uid, hubResponse?.conversationId || 0)
                        .then(() => {
                            console.log("Call rejection sent to hub.");
                        })
                        .catch((err) => {
                            console.error("Error invoking RejectCall:", err);
                        });
                    rejectVideoCall(hubResponse.roomId);
                    console.log("Call rejected");
                });
            }
        );

        // NEW: Listen for NotifyCallRingingOff to dismiss the call banner
        connection.on(
            "NotifyCallRingingOff",
            (data:NofifyForRingingOffDto) => {
                console.log("Notification recived", data);
                
                // You may need to implement a dismissCallNotification method in your notification context
                hideCallBanner();
            }
        );

        connection
            .start()
            .then(() => {
                console.log("✅ SignalR connected");
                console.log("Connection id : ", connection);
                
            })
            .catch((err) => {
                console.error("❌ SignalR connection error:", err);
            });

        // Cleanup on unmount or dependency change
        return () => {
            connection.stop();
        };
    }, [currentUser]);


    const rejectVideoCall = (roomId: string) => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                const payload: CallActionRequest = {
                    roomId: roomId
                }
                RejectVideoCallAsync(token, payload).then((res) => {

                }).catch((err) => {

                })
            }
        })
    }

    return null;
};


export default CallSignalRListener;
